import React from "react";
import LegalPage from "./LegalPage";
import { cancellationContent } from "./legalContent";

/**
 * /cancellation — stopping a subscription, and when money comes back.
 *
 * Separate from the Terms for the same reason as Delivery, and separate from
 * the withdrawal form because they answer different questions: this one says
 * what the rules are, the form is where a consumer acts on them.
 */
const Cancellation = () => <LegalPage content={cancellationContent} />;

export default Cancellation;
